export default "__VITE_ASSET__b1ac2407__"